module.exports = __webpack_public_path__ + "static/img/80713397.e9be01f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/80713397.svg
// module id = WlHU
// module chunks = 1